module.exports = __webpack_public_path__ + "static/img/icon-2.b80c274c.png";